// extracted by mini-css-extract-plugin
export default {"breadcrub_container":"index_breadcrub_container__P7Ebo","createdSearch":"index_createdSearch__plq0L","custom_table":"index_custom_table__SfzLX"};